import { ApolloLink } from "@apollo/client";
import { splitQueryBySchema } from "../graphql/compositionFragments/splitQueryBySchema";
import createMutationSchemaLink from "./createMutationSchemaLink";
import createSplitLinkObservable from "./createSplitLinkObservable";
function createExecutions(queriesBySchema, variables) {
    const executions = [];
    queriesBySchema.forEach((queryBySchema)=>{
        const { queryDoc, schemaLink, containsNonNullableFields, includeVariableNames } = queryBySchema;
        if (includeVariableNames.length > 0) {
            const isAnyIncludeVariableTrue = includeVariableNames.some((variableName)=>variables[variableName]);
            if (!isAnyIncludeVariableTrue) {
                return;
            }
        }
        executions.push({
            query: queryDoc,
            link: schemaLink,
            variables,
            containsNonNullableFields
        });
    });
    return executions;
}
/**
 * Creates a link that splits one requests into multiple - one per each schema.
 * It then executes each subquery through its own Apollo Link and stitches the
 * results back together.
 * @param schemaLinksConfiguration The schema links configuration. It contains the schema ID to Apollo link mapping and the top level field name to schema ID mapping.
 * @returns Apollo link that will handle both single and mixed schema queries.
 */ export default function createSplitBySchemaLink({ schemaIdToApolloLink, topLevelFieldNameToMetadata }) {
    const mutationLink = createMutationSchemaLink(schemaIdToApolloLink, topLevelFieldNameToMetadata.mutations);
    return new ApolloLink(function compositionQueryTerminatingLink(operation, forward) {
        var _operation_getContext_graphQlOperation;
        if (((_operation_getContext_graphQlOperation = operation.getContext().graphQlOperation) === null || _operation_getContext_graphQlOperation === void 0 ? void 0 : _operation_getContext_graphQlOperation.type) === 'MUTATION') {
            // Be aware that when used as a terminating link, forward is undefined
            return mutationLink.request(operation, forward);
        }
        const queriesBySchema = splitQueryBySchema(operation.query, topLevelFieldNameToMetadata.queries, schemaIdToApolloLink, operation.operationName);
        const executions = createExecutions(queriesBySchema, operation.variables);
        return createSplitLinkObservable(executions, operation);
    });
}

//# sourceMappingURL=createSplitBySchemaLink.js.map